module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agent-info-form "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }]
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getIndex) + "\n            "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDelBtnShow),
      expression: "hasDelBtnShow"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.deletefn(_vm.myIndex)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.agentInfo,
      "rules": _vm.rules,
      "label-width": "84px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合作项目",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeIntentProject
    },
    model: {
      value: (_vm.agentInfo.ProjectType),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ProjectType", $$v)
      },
      expression: "agentInfo.ProjectType"
    }
  }, _vm._l((_vm.intetPorjectList), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHavePolicy),
      expression: "isHavePolicy"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合作政策",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changePolicy
    },
    model: {
      value: (_vm.agentInfo.PolicyType),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "PolicyType", $$v)
      },
      expression: "agentInfo.PolicyType"
    }
  }, _vm._l((_vm.PoliceList), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "label": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHi),
      expression: "isHi"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合作级别",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentLevel
    },
    model: {
      value: (_vm.agentInfo.RebateLevel),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "RebateLevel", $$v)
      },
      expression: "agentInfo.RebateLevel"
    }
  }, _vm._l((_vm.LevelTypes), function(item, index) {
    return _c('el-radio', {
      attrs: {
        "label": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同号",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.ContractNumber),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ContractNumber", $$v)
      },
      expression: "agentInfo.ContractNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.areaList), function(item, index) {
    return _c('area-select', {
      ref: 'areaForm' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": index + 1,
        "isReadOnly": _vm.isReadOnly,
        "value": item,
        "label": '签约区域' + (index + 1),
        "hasDelFn": true,
        "label-width": "90px",
        "required": "",
        "disabled": _vm.disabled,
        "areaIsHide": _vm.setComHide
      },
      on: {
        "change": function($event) {
          _vm.areaSelectChange(index)
        },
        "delAreafn": _vm.delAreafn
      }
    })
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    class: [{
      marginLeft: _vm.setComHide
    }, _vm.addAreaClass],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addArea
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" 添加其他区域")])], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "授权经销期限"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "prop": "StartTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.StartDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "StartDate", $$v)
      },
      expression: "agentInfo.StartDate"
    }
  }), _vm._v("   -\n                                ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label-width": "0px",
      "prop": "EndDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.EndDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "EndDate", $$v)
      },
      expression: "agentInfo.EndDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIntent && _vm.agentInfo.ProjectType !== 4),
      expression: "!isIntent&&agentInfo.ProjectType!==4"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "区域保护期限"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "prop": "StartTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.DefendStartDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "DefendStartDate", $$v)
      },
      expression: "agentInfo.DefendStartDate"
    }
  }), _vm._v("   -\n                                ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label-width": "0px",
      "prop": "EndDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.DefendEndDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "DefendEndDate", $$v)
      },
      expression: "agentInfo.DefendEndDate"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIntent),
      expression: "isIntent"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "合作协议",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.CooperateIntent), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delcoop_Drawing(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.adcoop_container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.adcoop_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同预付款",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.agentInfo.ContractMoney),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ContractMoney", $$v)
      },
      expression: "agentInfo.ContractMoney"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIntent),
      expression: "!isIntent"
    }]
  }, [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "经销合同协议",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.HNC_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing2(_vm.agentInfo.HNC_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.browse_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.ContractMoney > 0),
      expression: "agentInfo.ContractMoney>0"
    }]
  }, [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "合同预付款打款凭证",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.ContractMoney_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.agentInfo.ContractMoney_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.ContractMoney_container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.ContractMoney_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isReadOnly) ? _c('div', [_c('el-form', [_c('h5', [_vm._v(_vm._s(_vm.getIndex))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作项目："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showData.ProjectTypeName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.PolicyTypeName !== ''),
      expression: "showData.PolicyTypeName!==''"
    }],
    attrs: {
      "label": "合作政策："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showData.PolicyTypeName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.RebateLevelName !== ''),
      expression: "showData.RebateLevelName!==''"
    }],
    attrs: {
      "label": "合作级别："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showData.RebateLevelName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.ContractNumber !== null),
      expression: "showData.ContractNumber!==null"
    }],
    attrs: {
      "label": "合同号："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.showData.ContractNumber) + "\n            ")]), _vm._v(" "), _vm._l((_vm.showData.AreaList), function(opts, index) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": '签约区域' + (index + 1)
      }
    }, [(opts.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(opts.ProvName) + "-" + _vm._s(opts.CityName) + "-" + _vm._s(opts.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(opts.ProvName) + "-" + _vm._s(opts.CityName))])])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权经销期限："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.agentInfo.StartDate) + " 至 " + _vm._s(_vm.agentInfo.EndDate) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.DefendStartDate !== ''),
      expression: "agentInfo.DefendStartDate!==''"
    }],
    attrs: {
      "label": "区域保护期限："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.agentInfo.DefendStartDate) + " 至 " + _vm._s(_vm.agentInfo.DefendEndDate) + "\n            ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.RebateLevel == 1),
      expression: "agentInfo.RebateLevel==1"
    }]
  }, [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "合作意向书："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.CooperateIntent), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同预付款："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.agentInfo.ContractMoney) + " 元\n            ")]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIntent),
      expression: "!isIntent"
    }]
  }, [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "经销合同协议："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.HNC_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showData.ContractMoney > 0),
      expression: "showData.ContractMoney>0"
    }]
  }, [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "合同款打款凭证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.ContractMoney_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1)], 2)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79296ed2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/agent-infonew/index.vue
// module id = 1532
// module chunks = 1